import { createSlice } from "@reduxjs/toolkit";

// export interface Filter {
//   label?: string;
//   key: string;
//   value: string;
//   global?: boolean;
// }

// Initial state è direttamente un array di filtri
export const _initialState = [];

const globalFiltersSlice = createSlice({
  name: "globalFilters",
  initialState: _initialState,
  reducers: {
    setGlobalFilter: (state, action) => {
      const filterIndex = state.findIndex(filter => filter.key === action.payload.key);
      if (filterIndex !== -1) {
        // Filtro esistente - aggiorna il valore
        state[filterIndex].value = action.payload.value || "";
      } else {
        // Filtro non esistente - crealo
        state.push({
          key: action.payload.key,
          value: action.payload.value || "",
          label: action.payload.label || action.payload.key,
          global: action.payload.global !== false // default true
        });
      }
    },

    setMultipleGlobalFilters: (state, action) => {
      action.payload.forEach(({ key, value, label, global }) => {
        const filterIndex = state.findIndex(filter => filter.key === key);
        if (filterIndex !== -1) {
          // Filtro esistente - aggiorna solo il valore
          state[filterIndex].value = value || "";
        } else {
          // Filtro non esistente - crealo
          state.push({
            key,
            value: value || "",
            label: label || key,
            global: global !== false // default true
          });
        }
      });

    },

    addGlobalFilter: (state, action) => {
      const existingIndex = state.findIndex(filter => filter.key === action.payload.key);
      if (existingIndex === -1) {
        state.push({
          key: action.payload.key,
          value: action.payload.value || "",
          label: action.payload.label || action.payload.key,
          global: action.payload.global !== false
        });
      }
    },

    removeGlobalFilter: (state, action) => {
      return state.filter(filter => filter.key !== action.payload);
    },

    resetGlobalFilters: (state) => {
      state.forEach(filter => {
        filter.value = "";
      });
    },

    updateFilterLabel: (state, action) => {
      const filterIndex = state.findIndex(filter => filter.key === action.payload.key);
      if (filterIndex !== -1) {
        state[filterIndex].label = action.payload.label;
      }
    },

    // Nuovo reducer per inizializzare filtri se necessario
    initializeFilters: (state, action) => {
      action.payload.forEach(filterConfig => {
        const existingIndex = state.findIndex(filter => filter.key === filterConfig.key);
        if (existingIndex === -1) {
          state.push({
            key: filterConfig.key,
            value: "",
            label: filterConfig.label || filterConfig.key,
            global: filterConfig.global !== false
          });
        }
      });
    },

    // Nuovo reducer per cancellare completamente tutti i filtri
    clearAllFilters: () => {
      return [];
    },
  },
});

// Selettori aggiornati per lavorare con lo state come array
export const selectAllFilters = (state) =>
  state.globalFilters || [];

export const selectFilterByKey = (state, key) =>
  (state.globalFilters || []).find(filter => filter.key === key);

export const selectFilterValue = (state, key) =>
  (state.globalFilters || []).find(filter => filter.key === key)?.value || "";

export const selectActiveFilters = (state) =>
  (state.globalFilters || []).filter(filter => filter.value !== "");

// Selettore per ottenere un oggetto con key-value dei filtri attivi
export const selectActiveFiltersAsObject = (state) =>
  (state.globalFilters || [])
    .filter(filter => filter.value !== "")
    .reduce((acc, filter) => {
      acc[filter.key] = filter.value;
      return acc;
    }, {});

// Selettore per ottenere tutti i filtri come oggetto key-value
export const selectAllFiltersAsObject = (state) =>
  (state.globalFilters || []).reduce((acc, filter) => {
    acc[filter.key] = filter.value || "";
    return acc;
  }, {});

export const {
  setGlobalFilter,
  setMultipleGlobalFilters,
  addGlobalFilter,
  removeGlobalFilter,
  resetGlobalFilters,
  updateFilterLabel,
  initializeFilters,
  clearAllFilters
} = globalFiltersSlice.actions;

export default globalFiltersSlice.reducer;